import { InjectionToken } from '@angular/core';
import { IPageable } from './paginator.model';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { ISort } from './sort.model';
import { IFilters } from './filters.model';

export const QUERY_CONFIG = new InjectionToken<SignalStoreConfig<QueryState<any>>>('query.config');
export const QUERY__SENTRYNEL_CONFIG = new InjectionToken<SignalStoreConfig<QueryStateSentrynel<any>>>('query.config');

export interface IQueryConfig {
  pageable?: IPageable,
  sort?: ISort,
  search?: string,
  // filters?: {
  //   [key: string]: string
  // },
  filters?: any,
}
export interface IQuerySentrynelConfig {
 meta?: {
    page?:number,
    totalItems?:number,
    totalPages?:number,
    currentPage?:number, 
    itemsPerPage?:number,
 },
  sort?: ISort,
  search?: string,
  // filters?: {
  //   [key: string]: string
  // },
  filters?: IFilters,
}

export interface QueryState<T = any> extends IQueryConfig {
  list: T[],
  isLoading: boolean
}
export interface QueryStateSentrynel<T = any> extends IQuerySentrynelConfig {
  list: T[],
  isLoading: boolean
}
export interface IQueryResponse {
  data: any
  message:string
  statusCode: number
  success: boolean
  timestamp: string
  meta: {
    currentPage: number
    itemsPerPage: number
    pageSize: number
    totalItems: boolean
    totalPages: any[]
 
  }
}
export interface IQueryResponseSentrynel {
  data: any
  empty: boolean
  first: boolean
  last: boolean
  number: number
  numberOfElements: number
  meta: {
    totalItems:number,
    totalPages:number,
    currentPage:number, 
    itemsPerPage:number,
    
  }
  size: number
  sort: any[]
  totalElements: number
  totalPages: number
}